// src/pages/Legal.jsx
export default function Legal() {
  return (
    <div className="min-h-screen bg-slate-950 py-10 px-4 text-slate-100">
      <div className="mx-auto max-w-3xl">
        <div className="rounded-2xl border border-slate-800/80 bg-slate-950/90 p-6 md:p-8 shadow-[0_18px_45px_rgba(15,23,42,0.9)]">
          <h1 className="text-3xl md:text-4xl font-extrabold mb-6 text-slate-50">
            Privacy Policy &amp; Terms of Service
          </h1>

          {/* Privacy Policy */}
          <section className="mb-10">
            <h2 className="text-xl md:text-2xl font-semibold mb-2 text-slate-50">
              Privacy Policy
            </h2>
            <p className="mb-4 text-sm leading-relaxed text-slate-300">
              Cpenn DFS (“we,” “our,” or “us”) respects your privacy. This policy
              explains how we collect, use, and protect your personal information
              when you use our site and tools.
            </p>

            <h3 className="font-semibold mt-4 mb-1 text-slate-100 text-sm">
              Information We Collect
            </h3>
            <ul className="list-disc list-inside mb-4 text-sm text-slate-300 space-y-1">
              <li>Email and account information when you sign up.</li>
              <li>Basic usage data (e.g., logins, tool interactions).</li>
              <li>
                We <strong>do not</strong> collect or store payment card details.
                All payments are securely processed through PayPal.
              </li>
            </ul>

            <h3 className="font-semibold mt-4 mb-1 text-slate-100 text-sm">
              How We Use Your Information
            </h3>
            <ul className="list-disc list-inside mb-4 text-sm text-slate-300 space-y-1">
              <li>To provide access to projections, tools, and site features.</li>
              <li>To improve our services and user experience.</li>
              <li>To communicate updates or account-related notices.</li>
            </ul>

            <h3 className="font-semibold mt-4 mb-1 text-slate-100 text-sm">
              Data Security
            </h3>
            <p className="mb-4 text-sm leading-relaxed text-slate-300">
              All information transmitted between your browser and our servers is
              encrypted using SSL (HTTPS). Passwords are securely stored by our
              authentication provider (Supabase).
            </p>
          </section>

          {/* Terms of Service */}
          <section>
            <h2 className="text-xl md:text-2xl font-semibold mb-2 text-slate-50">
              Terms of Service
            </h2>
            <p className="mb-4 text-sm leading-relaxed text-slate-300">
              By using Cpenn DFS, you agree to the following terms and conditions.
              If you do not agree, please discontinue use of our site and services.
            </p>

            <h3 className="font-semibold mt-4 mb-1 text-slate-100 text-sm">
              User Responsibilities
            </h3>
            <ul className="list-disc list-inside mb-4 text-sm text-slate-300 space-y-1">
              <li>Do not share your account credentials with others.</li>
              <li>Do not attempt to copy, scrape, or resell our projections or tools.</li>
              <li>You are responsible for maintaining the confidentiality of your account.</li>
            </ul>

            <h3 className="font-semibold mt-4 mb-1 text-slate-100 text-sm">
              Payments &amp; Access
            </h3>
            <p className="mb-4 text-sm leading-relaxed text-slate-300">
              All payments are processed securely through PayPal. We do not store
              credit card or banking information. Subscription access begins once
              payment is confirmed.
            </p>

            <h3 className="font-semibold mt-4 mb-1 text-slate-100 text-sm">
              Disclaimer
            </h3>
            <p className="mb-4 text-sm leading-relaxed text-slate-300">
              Our projections, tools, and simulations are for informational and
              entertainment purposes only. We do not guarantee results, profits,
              or winnings in Daily Fantasy Sports or sports betting. Use our data
              at your own risk.
            </p>

            <h3 className="font-semibold mt-4 mb-1 text-slate-100 text-sm">
              Limitation of Liability
            </h3>
            <p className="mb-2 text-sm leading-relaxed text-slate-300">
              Cpenn DFS is not liable for any financial losses, damages, or issues
              arising from the use of our tools, data, or website. All services are
              provided “as is” without warranty.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
